import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-287712a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-x" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Status:")
], -1))
const _hoisted_9 = { class: "col-md-8" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: ""
}, " -- select an option -- ", -1))
const _hoisted_11 = ["value", "disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Quality Control Person:")
], -1))
const _hoisted_15 = { class: "col-md-8" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sorry you can't change status to Printed or Packed without selected quality control user", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_20 = {
  key: 1,
  class: "row"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Manual Payment Method:")
], -1))
const _hoisted_22 = { class: "col-md-8" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sorry you can't change status without selected manual payment method or user", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "modal-footer" }
const _hoisted_27 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Save", -1))
const _hoisted_31 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_32 = { ref: "popupContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!
  const _component_GenericModalVue = _resolveComponent("GenericModalVue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_k_notification, { ref: "popupNotification" }, null, 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_GenericModalVue, {
        show: _ctx.isQualityControlModalOpen,
        "body-text": _ctx.qualityControlWarningMessage,
        "header-text": 'WARNING!!!',
        "is-question": true,
        "is-warning": true,
        "select-list": _ctx.adminUsers,
        onClose: _ctx.onQualityControlModalClose
      }, null, 8, ["show", "body-text", "select-list", "onClose"])
    ])),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-mask",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.oBackDropClick && _ctx.oBackDropClick(...args)))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h3", null, "Bulk Edit (" + _toDisplayString(_ctx.orderIds.length) + " " + _toDisplayString(_ctx.orderIds.length > 1 ? "orders" : "order") + ")", 1),
                    _createElementVNode("div", {
                      class: "close-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
                    }, _hoisted_5)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("select", {
                          class: "form-select",
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOrderStatusChange($event)))
                        }, [
                          _hoisted_10,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OrderStatuses, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.Id,
                              value: item.Id,
                              disabled: _ctx.isOrderStatusesUnselectable(item)
                            }, _toDisplayString(item.Name + (_ctx.isOrderStatusesUnselectable(item) ? " [unavailable]" : "")), 9, _hoisted_11))
                          }), 128))
                        ], 32)
                      ])
                    ]),
                    _hoisted_12,
                    (_ctx.isQualityControlRequired && !_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, [
                            (_ctx.isAnyAdminUsersAvailable)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: _normalizeClass({
                    'active-link': _ctx.isQualityControlConfigured,
                    'warning-link': !_ctx.isQualityControlConfigured,
                  }),
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onQualityUserEdit && _ctx.onQualityUserEdit(...args)))
                                }, _toDisplayString(_ctx.qualityControlUserSelected ? _ctx.qualityControlUserSelected?.Name : "<configure>"), 3))
                              : _createCommentVNode("", true),
                            (!_ctx.isAnyAdminUsersAvailable)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_19,
                    (_ctx.isPaymentMethodControlRequired && !_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            (_ctx.isAnyAdminUsersAvailable)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: _normalizeClass({
                    'active-link': _ctx.isPaymentMethodConfigured,
                    'warning-link': !_ctx.isPaymentMethodConfigured,
                  }),
                                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPaymentMethodEdit && _ctx.onPaymentMethodEdit(...args)))
                                }, _toDisplayString(_ctx.paymentMethodDetails), 3))
                              : _createCommentVNode("", true),
                            (!_ctx.isAnyAdminUsersAvailable)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _renderSlot(_ctx.$slots, "footer", {}, () => [
                      _createElementVNode("div", null, [
                        (_ctx.isLoading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          disabled: _ctx.isSaving,
                          class: "btn btn-danger",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.close()))
                        }, " Cancel ", 8, _hoisted_28)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          disabled: _ctx.isLoading || _ctx.isSaving || !_ctx.isFormValid,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveChanges()))
                        }, [
                          _hoisted_30,
                          (_ctx.isSaving)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_29)
                      ])
                    ], true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _createElementVNode("div", _hoisted_32, null, 512)
  ], 64))
}